export enum GeneralAppSettingEnum {
  ArchivePeriod = 1
}
